import type { PropsWithChildren } from 'react'
import React, { useEffect } from 'react'
import Typography from '../Typography/Typography'
import { useCheckbox } from './CheckboxContext'

function Label({
  children,
}: PropsWithChildren<Record<string, unknown>>): JSX.Element {
  const [{ groupId }, setLabelledBy] = useCheckbox()
  const id = `${groupId}-label`

  useEffect(() => setLabelledBy(id), [id, setLabelledBy])

  return (
    <Typography id={id} variant="subtitle2">
      {children}
    </Typography>
  )
}

export default Label
